import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';

import { AppContext } from '../../../../lib/Context';

/*

  The Button component is just a simple wrapper around a button HTML element.
  It adds no additional markup or styling and exists to simply add additional
  functionality that requires no additional props be passed in. Currently it just
  dispatches click integration actions, but can be used to add other non-intrusive
  behavior in the future. To add integration action data to the click events,
  simply wrap this component in AppContextIntegrationData in the parent's render
  function. All props provided to simple/Button will be passed through to the underlying
  HTML button element.

*/
const Button = React.memo(props => {
  const context = React.useContext(AppContext);
  const {
    action: { clicked },
    getActionData,
  } = get(context, 'integration', {});
  const { onClick, children, ...restProps } = props;

  const memoizedOnClick = React.useCallback(
    e => {
      if (!onClick) return;
      if (clicked && getActionData) {
        clicked(getActionData());
      }
      onClick(e);
    },
    [onClick, clicked, getActionData],
  );

  return (
    <button onClick={memoizedOnClick} {...restProps}>
      {children}
    </button>
  );
});

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default Button;
